import { UserPaymentTransactionLimited } from "@api-types/account-settings/UserPaymentTransactionLimited";
import { DepositResponseDto } from "@api-types/deposit";
import { PaymentRequestFilter } from "@data-types";
import { httpClient } from "@utils";
import { getApiRequestContext } from "@utils/api-config";
import { RequestContextType } from "@utils/api-config/RequestContext";
import { createApiRequestOptions } from "@utils/api-config/createApiRequestOptions";
import { getApplicationRequestHeaders } from "@utils/api-config/getApplicationRequestHeader";
import { ApiRequestContextData } from "@utils/api-config/types";

export class UserPaymentTransactionsApiService {
	static baseUrl(context: ApiRequestContextData | null): string {
		return `${WEBPACK_BASE_ADDRESS}${context?.agencyKey}/user-payment-transactions`;
	}

	static baseUrlWithAgencyIdentifier(agencyIdentifier: string) {
		return `${WEBPACK_BASE_ADDRESS}${agencyIdentifier}/user-payment-transactions`;
	}

	static getRequestHeaders = (context: ApiRequestContextData | null) => {
		const appHeaders = getApplicationRequestHeaders(context);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		appHeaders["Accept" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};

	static async getDepositData(
		bodyData: PaymentRequestFilter,
		options = createApiRequestOptions(RequestContextType.Online)
	): Promise<DepositResponseDto> {
		const context = getApiRequestContext(options);

		return await httpClient.post(
			`${this.baseUrl(context)}/deposits`,
			JSON.stringify(bodyData),
			this.getRequestHeaders(context)
		);
	}

	static async getWithdrawalData(
		bodyData: any,
		options = createApiRequestOptions(RequestContextType.Online)
	): Promise<any> {
		const context = getApiRequestContext(options);

		return await httpClient.post(
			`${this.baseUrl(context)}/payouts`,
			JSON.stringify(bodyData),
			this.getRequestHeaders(context)
		);
	}

	static async getTransactionDetails(
		agencyIdentifier: string,
		transactionId: string,
		options = createApiRequestOptions(RequestContextType.Online)
	): Promise<UserPaymentTransactionLimited> {
		const context = getApiRequestContext(options);

		return await httpClient.get(
			`${this.baseUrlWithAgencyIdentifier(agencyIdentifier)}/foruser/${transactionId}?embed=paymentMethod,currency,transactionStatus&translate=true`,
			this.getRequestHeaders(context)
		);
	}
}
